module.exports = __webpack_public_path__ + "img/BigCommerce.c50d1bcc.svg";